import React, { useCallback, useContext } from 'react';
import AppContainer from 'containers/AppContainer';
import Header from 'components/Header';
import Content from 'components/Content';
import Footer from 'components/Footer';
import Button from 'components/Button';
import MessageWithGif from 'components/MessageWithGif';
import { LocaleContext } from 'containers/LocaleContext';
import { useGetReceipt } from '../queries/useReceiptQueries';
import { useStore } from 'hooks/useStore';
import Loading from 'components/Loading';
export function Success() {
    const uid = useStore((s) => s.uid);
    const { I18n } = useContext(LocaleContext);
    const { data, isLoading } = useGetReceipt({
        uid: uid,
        options: {
            retry: 3,
            // 1st retry after 1.5s, then 3s, then 4.5s, throw if still erroring after 3 retries
            retryDelay: (attempt) => attempt * 1500,
        },
    });
    const handleSubmit = useCallback(() => {
        window.open(`${data === null || data === void 0 ? void 0 : data.url}`, '_blank');
    }, [data]);
    return (React.createElement(AppContainer, null,
        React.createElement(Header, { withGoBack: true }),
        isLoading ? (React.createElement(Loading, { state: "GENERATING" })) : (React.createElement(React.Fragment, null,
            React.createElement(Content.Wrapper, null,
                React.createElement(Content.Base, { padded: true },
                    React.createElement(MessageWithGif, { title: I18n.t('receipt_found.title'), text: I18n.t('receipt_found.text'), gifUrl: require('../assets/gifs/success.gif') }))),
            React.createElement(Footer, null,
                React.createElement(Button, { onClick: handleSubmit, disabled: !uid }, I18n.t('buttons.download_receipt')))))));
}
